import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Auth0Lock from 'auth0-lock';
import { withRouter, Link } from 'react-router-dom';
import { graphql, gql, withApollo, compose } from 'react-apollo';
import withAuth from 'hoc/withAuth';
import get from 'lodash/get';

import { Button, Menu, MenuItem } from 'components';

class AuthButton extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  state = {
    anchorEl: undefined,
    open: false,
  };

  _lock = new Auth0Lock(
    process.env.REACT_APP_AUTH0_CLIENT_ID,
    process.env.REACT_APP_AUTH0_DOMAIN,
    {
      language: 'en',
      languageDictionary: {
        title: 'Stack Stack',
      },
      avatar: null,
      theme: {
        logo: `${process.env.PUBLIC_URL}/logo.png`,
        primaryColor: '#4776e6',
      },
      auth: {
        redirect: false, // when redirect option false, it's not working. I don't know why https://auth0.com/forum/t/authenticated-event-not-triggering/3554/69
        responseType: 'token',
      },
    }
  );

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    // this._lock.on('show', () => {
    //   if (this.props.location.pathname !== '/') {
    //     this.props.history.push('/');
    //   }
    // });

    this._lock.on('authenticated', async authResult => {
      // process signin if user not logged in and auth0 id token exist
      if (!this.props.isLoggedIn && authResult && authResult.idToken) {
        const loggedInUser = await this.props.signinUser({
          variables: {
            idToken: authResult.idToken,
          },
        });

        if (!!get(loggedInUser, 'data.signinUser.user.id')) {
          localStorage.setItem('auth0IdToken', authResult.idToken);
          return this._resetApollo();
        }

        // process signup
        return this._lock.getUserInfo(
          authResult.accessToken,
          async (error, profile) => {
            if (error) {
              // Handle error
              return;
            }

            const signupUser = await this.createUser({
              idToken: authResult.idToken,
              name: profile.name,
            });
          }
        );
      }
    });
  }

  componentWillReceiveProps({ isLoggedIn }) {
    // if (isLoggedIn !== this.props.isLoggedIn) {
    //   this._resetApollo();
    // }
  }

  _resetApollo = () => {
    if (this.props.client) {
      this.props.client.resetStore();
      return this.props.history.replace('/');
    }

    return window.location.reload();
  };

  _showLogin = () => {
    return this._lock.show();
  };

  _logout = event => {
    event.preventDefault();

    this.handleRequestClose();
    // remove token from local storage and reload page to reset apollo client
    localStorage.removeItem('auth0IdToken');

    this._resetApollo();
  };

  createUser = userData => {
    const variables = {
      ...userData,
    };

    this.props
      .createUser({ variables })
      .then(response => {
        localStorage.setItem('auth0IdToken', userData.idToken);
        this._resetApollo();
      })
      .catch(e => {
        console.error(e);
        this._resetApollo();
      });
  };

  render() {
    const { isLoggedIn, currentUserName, ...rest } = this.props;

    if (!isLoggedIn) {
      return <Button {...rest} onClick={this._showLogin} />;
    }

    return (
      <div>
        <Button
          aria-owns="simple-menu"
          aria-haspopup="true"
          color="inherit"
          onClick={this.handleClick}
        >
          {currentUserName}
        </Button>
        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
        >
          <MenuItem onClick={this.handleRequestClose}>
            {currentUserName}
          </MenuItem>
          <MenuItem
            component={Link}
            to="/stack/add"
            onClick={this.handleRequestClose}
          >
            스택 추가
          </MenuItem>
          <MenuItem
            component={Link}
            to="/tool/add"
            onClick={this.handleRequestClose}
          >
            툴 추가
          </MenuItem>
          <MenuItem onClick={this._logout}>Logout</MenuItem>
        </Menu>
      </div>
    );
  }
}

const createUser = gql`
  mutation($idToken: String!, $name: String!) {
    createUser(authProvider: { auth0: { idToken: $idToken } }, name: $name) {
      id
    }
  }
`;

const signinUser = gql`
  mutation login($idToken: String!) {
    signinUser(auth0: { idToken: $idToken }) {
      token
      user {
        id
        name
      }
    }
  }
`;

export default compose(
  graphql(createUser, { name: 'createUser' }),
  graphql(signinUser, { name: 'signinUser' }),
  withAuth,
  withRouter,
  withApollo
)(AuthButton);



// WEBPACK FOOTER //
// ./src/common/components/AuthButton.js